/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_TitleInputs */

const en_dispatch_title = /** @type {(inputs: Dispatch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New task`)
};

const fr_dispatch_title = /** @type {(inputs: Dispatch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle tâche`)
};

const ms_sg2_dispatch_title = /** @type {(inputs: Dispatch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugasan baru`)
};

/**
* | output |
* | --- |
* | "New task" |
*
* @param {Dispatch_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_title = /** @type {((inputs?: Dispatch_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_title(inputs)
	if (locale === "fr") return fr_dispatch_title(inputs)
	return ms_sg2_dispatch_title(inputs)
});